



















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { CreateElement, RenderContext } from "vue";
import { Location } from "vue-router";

@Component
export default class UGridItem extends Vue {
  // Props
  @Prop({ default: "" })
  public readonly action!: string | TranslateResult;

  @Prop({ default: "chevron-right" })
  public readonly actionIcon!: string;

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: true })
  public readonly isClickable!: boolean;

  @Prop({ default: "" })
  public readonly icon!: string;

  @Prop({ default: "" })
  public readonly iconLabel!: string;

  @Prop({ default: undefined })
  public readonly iconRouterLink?: Location;

  @Prop({ default: "fas" })
  public readonly iconPack!: string;

  @Prop({ default: "is-dark" })
  public readonly iconType!: string;

  @Prop({ default: true })
  public readonly multilined!: boolean;

  @Prop({ default: null })
  public readonly iconEmitAction!: string;

  @Prop({ default: false })
  public readonly iconDisabled!: boolean;

  @Prop({ default: false })
  public readonly isSelectable!: boolean;

  @Prop({ default: true })
  public readonly isMultiselect!: boolean;

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly isSelected!: boolean;

  @Prop({ default: false })
  public readonly isSortable!: boolean;

  @Prop({ default: false })
  public readonly isSortableDisabled!: boolean;

  @Prop({ default: "" })
  public readonly radioCheckLabel!: string | TranslateResult;

  @Prop({ default: false })
  public readonly actionIsDisabled!: boolean;

  // Computed

  public get hasSkeletons() {
    return !!this.$slots?.skeletons;
  }

  public get hasRouterLink() {
    return !this.$_.isEmpty(this.$attrs.to);
  }

  public get component() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) => {
        return h(
          this.hasRouterLink && !this.isSelectable ? "router-link" : "a",
          {
            class: [
              "u-grid-item",
              !this.hasSkeletons && this.isClickable && "is-clickable",
              this.hasSkeletons && "has-skeletons",
              this.isSelected && "is-selected"
            ],
            props: this.hasRouterLink ? this.$attrs : undefined,
            on: {
              ...this.$listeners,
              click: this.onClick
            }
          },
          children
        );
      }
    };
  }

  // Methods

  public onSelect() {
    if (this.isDisabled || !this.isSelectable) return;
    return this.$emit("select", !this.isSelected);
  }

  public onCtaClick($event) {
    if (this.isDisabled || this.actionIsDisabled) return;
    return this.$emit("ctaClick", $event);
  }

  public onClick() {
    if (this.isDisabled) return;
    this.$emit("click");

    this.onSelect();
  }
}
